import {
  getAccountImpersonationAPI,
  getAccountPermissionsAPI,
} from '@constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchPermissions = createAsyncThunk(
  'accounts/fetchPermissions',
  async () => {
    const res = await axios.get(getAccountPermissionsAPI(), {
      withCredentials: true,
    });
    return res.data;
  },
);

export const setImpersonation = createAsyncThunk(
  'accounts/setImpersonation',
  async (account: { id: string; name: string }) => {
    await axios.post(
      getAccountImpersonationAPI(),
      { ...account },
      { withCredentials: true },
    );
    return account.id;
  },
);
